<template>
    <div class="people d-flex flex-column">
        <div>
            <div class="navigator">
                <h2 class="mr-auto">My Agents</h2>

                <!-- <button class="btn secondary wide mr-3" @click="triggerNewMessage">
                    <i class="ico-email large"></i>
                    New Message
                </button> -->

                <invite></invite>
            </div>
        </div>

        <div class="flexGrow1 overflow-auto">
            <tabs>
                <tab name=" ">
                    <agents></agents>
                </tab>
                <!-- <tab name="Inactive">
                    <empty></empty>
                </tab> -->
            </tabs>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    import Agents from './PeopleAgents'
    import Invite from './agents/AgentInviteButton'
    import Empty from '@/tools/Empty'

    export default {
        created: function() {
            // this.init();

            /** options not available for now

            this.options = [
                { label: 'Agent', fn: this.openModal, value: 'AgentAdd' },
                { label: 'Team', fn: this.openModal, value: 'TeamAdd' },
                { label: 'Customer', fn: this.openModal, value: 'CustomerAdd' },
            ]

            */

            //refresh agent list
            this.downloadAgents()
        },
        methods: {
            ...mapActions([
                'initPeople',
                'refreshAccountData',
                'openNewMessageModal',
                'openModal',
                'downloadAgents'
            ]),
            triggerNewMessage: function() {
                this.openNewMessageModal('agent');
            },
            // async init() {
            //     //await this.refreshAccountData().then(() => {
            //         this.initPeople();
            //     //});
            // },
        },
        computed: {
            ...mapGetters([
                'getAgents'
            ])
        },
        components: {
            Agents,
            Empty,
            Invite,
        },
    }
</script>



// WEBPACK FOOTER //
// People.vue?251566de